import { AppDispatch } from "core/src/store/store.types";
import { useDispatch } from "react-redux";
import { postToast as postToastUC, PostToastRequest, ToastType } from "./useCases/postToast/postToast.use-case";
import {
    displayFrontErrorToast as displayFrontErrorToastUC,
    DisplayFrontErrorToastRequest
} from "./useCases/display-front-error-toast/display-front-error-toast.use-case";
import {
    displayApiErrorToast as displayApiErrorToastUC,
    DisplayApiErrorToastRequest
} from "./useCases/display-api-error-toast/display-api-error-toast.use-case";

export const useUiUseCases = () => {
    const dispatch = useDispatch<AppDispatch>();

    const postToast = (args: PostToastRequest) => dispatch(postToastUC(args));
    const displaySuccessToast = ({ message }: { message: string }) => postToast({ type: ToastType.SUCCESS, message });
    const displayWarnToast = ({ message }: { message: string }) => postToast({ type: ToastType.WARN, message });
    const displayErrorToast = ({ message }: { message: string }) => postToast({ type: ToastType.ERROR, message });
    const displayFrontErrorToast = (args: DisplayFrontErrorToastRequest) => dispatch(displayFrontErrorToastUC(args));
    const displayApiErrorToast = (args: DisplayApiErrorToastRequest) => dispatch(displayApiErrorToastUC(args));

    return {
        postToast,
        displaySuccessToast,
        displayWarnToast,
        displayErrorToast,
        displayFrontErrorToast,
        displayApiErrorToast
    };
};

export type UseUiUseCases = ReturnType<typeof useUiUseCases>;
